import { Truck } from 'lucide-react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';

/*
  What Purchasing has to configure, and today it is one list: who the organization buys from.

  A SUPPLIER IS A RECORD AND STILL SITS HERE, on the work-versus-configuration test rather than
  on what it is. The work surfaces in this group are the purchase request and the purchase
  order; a supplier is what an order DRAWS ON — every order form picks one, and nothing is done
  to a supplier itself. That is the same answer Items took on 18 Sep 2026 once the stock
  surfaces arrived beside it, and it could change again the day a reader can do something to a
  supplier: the test is a property of what ELSE exists, not of the module.
*/
const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'suppliers',
    label: 'Suppliers',
    description:
      'The counterparties the organization buys from. Every purchase order names one, and the order form offers only the live ones.',
    icon: Truck,
    to: '/procurement/purchasing/settings/suppliers',
    permission: 'suppliers.read',
  },
];

/**
 * Procurement → Purchasing → Settings: a menu of what the module group configures.
 *
 * An extension of the sidebar, which is what keeps the rail at one entry per module rather than
 * growing a row per configurable list.
 */
export function PurchasingSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Procurement', 'Purchasing', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-auto p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          {/*
            One line, and it says what the menu cannot: an order cannot be placed at all until
            this list holds a row, which is what the order page's own prerequisite banner then
            states where the reader meets it.
          */}
          <p className="text-xs text-slate-500">
            What the buying cycle draws on. A purchase order names a supplier, so this list has to
            hold a row before one can be placed.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
